<div class="material-page">

  <mat-stepper linear #stepper labelPosition="bottom" color="accent" (selectionChange)="onStepChange($event)">
  
    <mat-step state="first_picture" [stepControl]="firstPictureForm">
      <form (submit)="askForRecommendations()">
        <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-9">
              <h2 style="display: flex; align-items: center" class="smartphone-note">
                <mat-icon fontSet="material-symbols-outlined" style="margin-right: 5px; vertical-align: middle;">smartphone</mat-icon>
                <ng-container i18n>Use your smartphone for the best experience</ng-container>
              </h2>
              <h1 i18n>Add a picture of the item you want to sell</h1>
              <p>
                <mat-icon fontSet="material-symbols-outlined" style="margin-right: 5px; font-size: 29px">priority_high</mat-icon>
                <ng-container i18n>Make sure the entire item fits on the photo and stands out clearly so we know what you’re selling</ng-container>
              </p>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3">
              <image-list-editor [maxImages]="1" [pictures]="firstPicture" (onChange)="numberOfPicturesOnFirstStepChanged()" (onUploadingStateChange)="onPicturesUploadingStateChange()"/>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
              <div class="button-panel">
                <button 
                      type="submit"
                      mat-raised-button 
                      color="accent"
                      [disabled]="loadingRecommendations || picturesUploading"
                      angulartics2On="click" 
                      angularticsAction="GoToSecondStepOfSnapAndSellClick">
                    <span class="with-spinner">
                      <mat-spinner *ngIf="loadingRecommendations || picturesUploading" [diameter]="16"></mat-spinner>
                      <span i18n>Next</span>
                    </span>
                </button>
                <mat-error *ngIf="firstPictureForm.controls['picturesLength'].touched && firstPictureForm.controls['picturesLength'].errors?.['min']" i18n>You have to take a picture to proceed</mat-error>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    
    <mat-step state="second_picture">
      <div class="mdc-layout-grid" *ngIf="!loadingRecommendations">
        <div class="mdc-layout-grid__inner">
        
          <h3 *ngIf="itemType" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" i18n>
            Creating a listing for a <b>{{itemType.toLowerCase()}}</b> <a (click)="prev()"> (change)</a>
          </h3>
        
          <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
            <h1 i18n>Follow the instructions and add a few more pictures</h1>
          </div>
          
          <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" *ngFor="let recommendation of recommendations">
            <h2>{{recommendation.title}}</h2>
            <p>{{recommendation.description}}</p>
            <image-list-editor [maxImages]="5" [pictures]="getRecommendationPictures(recommendation)" (onUploadingStateChange)="onPicturesUploadingStateChange()"/>
          </div>
          
          <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
            <div class="button-panel">
              <button matStepperPrevious
                  mat-button
                  angulartics2On="click" 
                  angularticsAction="GoBackToFirstStepOfSnapAndSellClick" i18n>Back</button>
              
              <button matStepperNext 
                  mat-raised-button color="accent" 
                  angulartics2On="click" 
                  [disabled]="picturesUploading"
                  angularticsAction="GoToThirdStepOfSnapAndSellClick">
                <span class="with-spinner">
                  <mat-spinner *ngIf="picturesUploading" [diameter]="16"></mat-spinner>
                  <span i18n>Next</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-step>
    
    <mat-step state="manual" [stepControl]="manualForm">
      <form [formGroup]="manualForm" (ngSubmit)="createListing()">
        <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
            
              <div style="display: flex; align-items: center;">
                <h1 class="mat-headline-4" style="margin-bottom: 0px;" i18n>Tell us the current condition of the item</h1>
              </div>
            
              <mat-radio-group class="radio-group" formControlName="condition" required>
                <mat-radio-button value="1" i18n>New</mat-radio-button>
                <mat-radio-button value="2" i18n>Used - like new / open box</mat-radio-button>
                <mat-radio-button value="3" i18n>Used - very good</mat-radio-button>
                <mat-radio-button value="4" i18n>Used - good</mat-radio-button>
                <mat-radio-button value="5" i18n>Used - fair</mat-radio-button>
                <mat-radio-button value="6" i18n>Used - poor / for parts or not working</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="manualForm.controls['condition'].touched && manualForm.controls['condition'].errors?.['required']" i18n="error when condition not selected">Select condition</mat-error>
            </div>
            
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
              <div class="button-panel">
                <button matStepperPrevious
                  mat-button
                  angulartics2On="click" 
                  angularticsAction="GoBackToSecondStepOfSnapAndSellClick" i18n>Back</button>
                
                <button type="submit"
                      mat-raised-button 
                      color="accent"
                      [disabled]="loading"
                      angulartics2On="click" 
                      angularticsAction="CreateSnapAndSellListingClick">
                    <span class="with-spinner">
                      <mat-spinner *ngIf="loading" [diameter]="16"></mat-spinner>
                      <span i18n>NEXT</span>
                    </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    
    <ng-template matStepperIcon="done">
      <mat-icon style="color: black" fontSet="material-symbols-outlined">done</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="edit" let-index="index">
      <mat-icon style="color: black" fontSet="material-symbols-outlined">
        {{ getStepIcon(index) }}
      </mat-icon>
    </ng-template>
    <ng-template matStepperIcon="first_picture" let-active="active">
      <mat-icon [style.color]="active ? 'black' : 'white'" fontSet="material-symbols-outlined">add_a_photo</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="second_picture" let-active="active">
      <mat-icon [style.color]="active ? 'black' : 'white'" fontSet="material-symbols-outlined">add_a_photo</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="manual" let-active="active">
      <mat-icon [style.color]="active ? 'black' : 'white'" fontSet="material-symbols-outlined">edit_note</mat-icon>
    </ng-template>
  </mat-stepper>
</div>